export default __webpack_public_path__ + "static/media/Landing1.3dcf3be6.jpg";